<template>
  <div>
    <div v-if="render">
      <b-row>
        <b-col>
          <b-button variant="success" class="float-right mb-2" v-b-toggle.neuerKontakt><font-awesome-icon icon="plus"/> Neuer Kontakt</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-collapse id="neuerKontakt" class="mb-4" v-model="visible">
            <b-card>
              <b-row>
                <b-col>
                  <b-button
                    variant="outline-secondary"
                    size="sm"
                    class="float-right"
                    @click="neuerKontaktCancel"
                    v-b-tooltip.hover title="Abbrechen"
                    >X</b-button>

                </b-col>
              </b-row>
              
              <b-form id="KontaktNeuAnlegen" @submit.prevent="adminBenutzerNeuerKontakt">
                <b-form-row>
                  <b-col cols="12" md="6">
                    <b-form-group id="neuer-kontakt-vorname-group" label="Vorname *" label-for="vorname">
                      <b-form-input
                        id="neuer-kontakt-vorname"
                        v-model="neuerKontakt.vorname"
                        type="text"
                        :state="vornameState"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group id="neuer-kontakt-name-group" label="Name *" label-for="name">
                      <b-form-input
                        id="neuer-kontakt-name"
                        v-model="neuerKontakt.name"
                        type="text"
                        :state="nameState"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col cols="12" sm="6">
                    <b-form-group id="neuer-kontakt-email-group" label="E-Mail Adresse für Benachrichtigungen" label-for="email">
                      <b-form-input
                        id="neuer-kontakt-email"
                        v-model="neuerKontakt.email"
                        type="email"
                        :state="emailState"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6">
                    <b-form-group id="neuer-kontakt-mobil-group" label="Mobilnummer für Benachrichtigungen" label-for="mobil">
                      <b-form-input id="neuer-kontakt-mobil" v-model="neuerKontakt.mobil" type="text" :state="mobilState"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <hr />

                <b-row>
                  <b-col>
                    <b-form-group>
                      <b-form-checkbox
                        id="neuer-kontakt-favorit"
                        v-model="neuerKontakt.favorit"
                        name="favorit"
                        value="1"
                        unchecked-value="0"
                      >Notfallbenachrichtigungen an diesen Kontakt senden</b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    
                    <b-button
                      type="submit"
                      variant="success"
                      class="float-right"
                      v-bind:disabled="!neuerKontaktValidation"
                    >Neuen Kontakt speichern</b-button>
                    <b-button
                    variant="secondary"
                    class="float-right mr-2"
                    @click="neuerKontaktCancel"
                    >Abbrechen</b-button>
                  </b-col>
                </b-row>
                <p class="text-left small">mit * gekennzeichnete Felder sind Pflichtfelder</p>
              </b-form>
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>


      <div v-if="benutzerKontakte.length == 0">
        <b-alert variant="danger" show>Keine Kontakte gefunden.</b-alert>
      </div>
      <div v-else>
        <b-row class="mb-3">
          <b-col><strong>Name</strong></b-col>
          <b-col><strong>E-Mail</strong></b-col>
          <b-col><strong>Mobilnummer</strong></b-col>
          <b-col></b-col>
        </b-row>
        <hr>
        <div v-for="kontakt in benutzerKontakte" :key="kontakt.id" class="mb-3 py-2 border-bottom">
          <BenutzerKontaktBearbeitenRow :kontakt="kontakt" :benutzer="benutzer" @updUserToast="emitToast"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BenutzerKontaktBearbeitenRow from './BenutzerKontaktBearbeitenRow'

export default {
  name: 'BenutzerKontakteBearbeiten',
  props: ["benutzer"],
  components: {
    BenutzerKontaktBearbeitenRow
  },
  computed: {
    ...mapGetters(['alleBenutzer', 'adminStatus']),
    vornameState() {
      if (this.neuerKontakt.vorname === "") return null;

      return this.neuerKontakt.vorname.length > 2 ? true : false;
    },
    nameState() {
      if (this.neuerKontakt.name === "") return null;

      return this.neuerKontakt.name.length > 2 ? true : false;
    },
    emailState() {
      if (this.neuerKontakt.email === "") return null;

      return this.emailRegex.test(this.neuerKontakt.email) ? true : false;
    },
    mobilState() {
      if (this.neuerKontakt.mobil === null || this.neuerKontakt.mobil === "") return null;

      return this.neuerKontakt.mobil.length > 2 ? true : false;
    },
    neuerKontaktValidation() {
      return this.vornameState && this.nameState
        ? true
        : false;
    }
  },
  methods: {
    ...mapActions(['adminGetBenutzerKontakte', 'adminBenutzerKontaktAnlegen']),
    adminBenutzerNeuerKontakt () {
      this.adminBenutzerKontaktAnlegen({userId: this.benutzer.id, kontakt: this.neuerKontakt}).then(() => {
        const toastData = {
          title: "",
          msg: "Der Kontakt wurde geändert.",
          variant: "success"
        };

        if (this.adminStatus.errMsg) {
          (toastData.title = "Es ist etwas schief gelaufen."),
            (toastData.msg = this.adminStatus.errMsg);
          toastData.variant = "danger";
        }

        this.$emit("updUserToast", toastData);

        if (!this.adminStatus.errMsg) {
          this.visible = false
          this.neuerKontakt = {
            vorname: '',
            name: '',
            email: '',
            mobil: '',
            favorit: 0
          }
        }
      });
    },
    neuerKontaktCancel () {
      this.visible = false
      this.neuerKontakt = {
        vorname: '',
        name: '',
        email: '',
        mobil: '',
        favorit: 0
      }
    },
    emitToast (toastData) {
      this.$emit("updUserToast", toastData)
    },
  },
  data () {
    return {
      emailRegex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
      render: false,
      benutzerKontakte: [],
      neuerKontakt: {
        vorname: '',
        name: '',
        email: '',
        mobil: '',
        favorit: 0
      },
      visible: false 
    }
  },
  mounted() {
    this.render = false

    this.adminGetBenutzerKontakte(this.benutzer.id)
      .then(() => {
        let index = this.alleBenutzer.findIndex(b => b.id === this.benutzer.id)
        if (index !== null) {
          this.benutzerKontakte = this.alleBenutzer[index].kontakte
          this.render = true
        }
      })
  }

}
</script>

<style>

</style>